module.exports = __webpack_public_path__ + "static/juvencard@3x.8bbce50b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvencard@3x.png
// module id = 726
// module chunks = 92562407457355